
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMessageImportantGoogle as ObiMessageImportantGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-message-important-google.js';
 
 
 

 
 export const ObiMessageImportantGoogle = createComponent({
   react: React,
   tagName: 'obi-message-important-google',
   elementClass: ObiMessageImportantGoogleElement,
   events: {
     
   }
  });
 
 